import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Landing from './landing_page.js';
import Links from './links_page.js';
import Juugs from './juug_page.js';
import ArtistUpload from './upload_page.js';
import Login from './login_page.js';
import TicketPage from './tickets_page.js';
import AllTicketsPage from './all_tickets_page.js';
import EventsPage from './events_page.js';
import ScanPage from './scan_page.js';
import RequestsPage from './requests_page.js';
import MediaPage from './media_page.js';
import FreeJuugs from './free_juugs_page.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path='/login' element={<Login/>}/>
        <Route path='/link' element={<Links/>}/>
        <Route path='/juug' element={<Juugs/>}/>
        <Route path='/upload' element={<ArtistUpload/>}/>
        <Route path='/events' element={<EventsPage/>}/>
        <Route path='/tickets' element={<AllTicketsPage/>}/>
        <Route path='/tickets/:artist' element={<TicketPage/>}/>
        <Route path='/scan' element={<ScanPage/>}/>
        <Route path='/requests' element={<RequestsPage/>}/>
        <Route path='/media' element={<MediaPage/>}/>
        <Route path='/free-juugs' element={<FreeJuugs/>}/>
      </Routes>
    </Router>
  );
}

export default App;
